import { useEffect, useState } from "react"
import { Calendar } from "../../../components/calendar/calendar"
import { AdminHeader } from "../../../components/adminHeader/adminHeader"
import { usePopup } from "../../../components/popup/popup"
import { WeekDayPopup } from "./weekDayPopup"
import { useLocation, useParams } from "react-router"
import TableAPI from "../../../api/TableAPI"
import classNames from "classnames"
import qs from "qs"
import { Button } from "../../../components/button/button"
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate"

import styles from "./tablePage.module.css"
import AdminAPI from "../../../api/AdminAPI"

export const CafeTablePage = () => {
    const { cafeId } = useParams();
    const { search } = useLocation();
    const searchParams = qs.parse(search.replace("?", ""));

    const [date, setDate] = useState(new Date(searchParams.initialYear ||new Date().getFullYear(), searchParams.initialMonth || new Date().getMonth(), 1));
    const [shifts, setShifts] = useState([]);

    const [Popup, open] = usePopup();

    const [cafeInfo, setCafeInfo] = useState({maxEmpCount: 0});

    useEffect(() => {
        if (cafeId === null) return;

        AdminAPI
            .fetchCafeInfo(cafeId)
            .then(setCafeInfo)
            .catch(console.error);
    }, [cafeId]);

    useEffect(() => {
        if (cafeId === null) return;

        TableAPI
            .fetchAdminShiftsMonthly(cafeId, date.getFullYear(), date.getMonth() + 1)
            .then(setShifts)
            .catch(console.error);
    }, [cafeId, date]);

    const getShiftType = (shift) => {
        if (!shift) return "primary";
        const k = shift.countEmployees;
        return (k === 0) ? "primary" : (k < cafeInfo.maxEmpCount) ? "mean" : "high";
    }

    const [popupParams, setPopupParams] = useState({ date: new Date(), curShift: null });

    const [isAdding, setIsAdding] = useState(false);
    const [selectedDays, setSelectedDays] = useState([]);

    const onDayClicked = (date, curShift) => {
        if (isAdding) {
            setSelectedDays(prev => {
                if (prev.some(el => el.getTime() === date.getTime())) {
                    return prev.filter(d => d.getTime() !== date.getTime());
                } else {
                    return [...prev, date];
                }
            });
        } else {
            setPopupParams({ date, curShift });
            open();
        }
    }

    const navigate = useAnimatedNavigate();
    const onAddClick = () => {
        if (!isAdding) {
            setIsAdding(true);
            return;
        }
        if (selectedDays.length === 0) return;
        const query = qs.stringify({
            dates: selectedDays.map(d => d.getTime()),
        });
        navigate(`/superadmin/cafe/${cafeId}/table/add?${query}`);
    }

    return (
        <>
            <AdminHeader title="Табель" />

            <Calendar date={date} setDate={setDate} shifts={shifts} shiftType={getShiftType} onClick={onDayClicked} selectedDates={selectedDays} />

            <div className={styles.explanation_container}>
                <div className={classNames(styles.explanation_item, styles.high)}>Смена сформирована</div>
                <div className={classNames(styles.explanation_item, styles.mean)}>Смена сформирована не до конца</div>
                <div className={classNames(styles.explanation_item, styles.low)}>Смена еще не сформирована</div>
            </div>

            <Popup>
                <WeekDayPopup date={popupParams.date} shift={popupParams.curShift} setShift={(editedShift) => {
                    const newShifts = shifts.filter(el => el.shiftDate !== editedShift.shiftDate);
                    newShifts.push(editedShift);
                    setShifts(newShifts);
                }} />
            </Popup>

            <div className={classNames(styles.add_shifts_container, { [styles.active]: isAdding })}>
                <div style={{
                    overflow: "hidden",
                    minWidth: "0px",
                }}>
                    <Button
                        style={{ marginRight: "10px" }}
                        text="Отменить"
                        type="secondary"
                        onClick={() => {
                            setIsAdding(false);
                            setSelectedDays([]);
                        }}
                    />
                </div>
                <Button
                    text={isAdding ? "Подтвердить" : "Назначить смены"}
                    onClick={onAddClick}
                />
            </div>
        </>
    )
}
